import { ServiceType } from "../services/service-type.model"
import { ServicesByModelGroup } from "../services/services-by-model-group.model";

export class ScheduleServices {
  "selected": boolean;
  "active": boolean;
  "costless": boolean;
  "country": string;
  "createTime": string;
  "createUser": string;
  "dealer": string;
  "displayToCustomers": boolean;
  "divisionId": number;
  "dmsCode": string | null;
  "duration": number;
  "fixedPrice": boolean;
  "fordPrice": number;
  "includedInWorkshopTime": boolean;
  "kmFrom"?: number;
  "kmTo"?: number;
  "months": number;
  "name": string;
  "needsDealerApproval": boolean;
  "prevMaintenance": boolean;
  "promotionalActive": boolean;
  "promotionalDescription"?: string;
  "promotionalEndDate"?: string;
  "promotionalEndHour"?: string;
  "promotionalPrice": number;
  "promotionalStartDate"?: string;
  "promotionalStartHour"?: string;
  "revisionCode": number;
  "serviceId": number;
  "serviceName": string;
  "servicePrice": number;
  "serviceType": ServiceType;
  "serviceTypeId": number;
  "servicesByModelGroup": ServicesByModelGroup[]
  "updateTime": string
  "updateUser": string
  "winchService": boolean;
  "msvApplicable": boolean;
}
